export default "__VITE_ASSET__CnEz9kAW__"